"use strict";

const TEMPLATE_ID = "editor-confirm-box";

const template = `
<template id="${TEMPLATE_ID}">
    <div class="popup-content popup-dialog" style="display: flex; flex-direction: column">
        <div class="hbox">
            <span id="confirmMessage">Do you want to save the changes to this card?</span>
        </div>
        <div class="hbox" style="display: flex; justify-content: center; padding-top: 10px">
            <button id="confirm-accept" class="btn btn-primary">Yes</button>
            <button id="confirm-cancel" class="btn">Cancel</button>
            <button id="confirm-reject" class="btn">No</button>
        </div>
    </div>
</template>
`;

if (document.querySelector(`template[id=${TEMPLATE_ID}]`) == null) {
    document.body.insertAdjacentHTML("afterbegin", template);
}

const popupControl = require("js/controls/popup_control.js");

const USER_CHOICE_SAVE = "user-choice-save";
const USER_CHOICE_CANCEL = "user-choice-cancel";
const USER_CHOICE_REJECT = "user-choice-reject";
module.exports.USER_CHOICE_SAVE = USER_CHOICE_SAVE;
module.exports.USER_CHOICE_CANCEL = USER_CHOICE_CANCEL;
module.exports.USER_CHOICE_REJECT = USER_CHOICE_REJECT;

module.exports.confirm = (message = null) => {
    return new Promise((resolve, reject) => {
        const template = document.getElementById("editor-confirm-box");
        const box = template.content.cloneNode(true);

        if (message != null) {
            const confirmMessage = box.querySelector("#confirmMessage");
            confirmMessage.innerText = message;
        }

        const closeOnEscape = (event) => {
            const key = event.key;
            if (key === "Escape") {
                console.log("ESC pressed: hide popup");
                document.removeEventListener("keydown", closeOnEscape);
                popupControl.hide();
                resolve(USER_CHOICE_CANCEL);
            }
            if (key === "Enter") {
                console.log("Enter pressed: hide popup");
                document.removeEventListener("keydown", closeOnEscape);
                popupControl.hide();
                resolve(USER_CHOICE_SAVE);
            }
        };

        const confirmButton = box.querySelector("#confirm-accept");
        confirmButton.addEventListener("click", () => {
            popupControl.hide();
            document.removeEventListener("keydown", closeOnEscape);
            resolve(USER_CHOICE_SAVE);
        });
        box.querySelector("#confirm-cancel").addEventListener("click", () => {
            popupControl.hide();
            document.removeEventListener("keydown", closeOnEscape);
            resolve(USER_CHOICE_CANCEL);
        });
        document.addEventListener("keydown", closeOnEscape);

        box.querySelector("#confirm-reject").addEventListener("click", () => {
            popupControl.hide();
            document.removeEventListener("keydown", closeOnEscape);
            resolve(USER_CHOICE_REJECT);
        });

        popupControl.show(box, confirmButton); // focus the confirm button
    });
};

module.exports.confirmDangerousAction = (opts = {}) => {
    const { message = null, messageIsHtml = false, cancelButton = true, rejectButton = true } = opts;

    return new Promise((resolve, reject) => {
        const template = document.getElementById("editor-confirm-box");
        const box = template.content.cloneNode(true);

        if (message != null) {
            const confirmMessage = box.querySelector("#confirmMessage");
            if (messageIsHtml) {
                confirmMessage.innerHTML = message;
            } else {
                confirmMessage.innerText = message;
            }
        }

        if (!cancelButton) {
            const button = box.querySelector("#confirm-cancel");
            button.classList.add("disabled");
        }

        if (!rejectButton) {
            const button = box.querySelector("#confirm-reject");
            button.classList.add("disabled");
        }

        const confirmAccept = box.querySelector("#confirm-accept");
        confirmAccept.classList.add("btn-danger");
        confirmAccept.addEventListener("click", () => {
            popupControl.hide();
            resolve(USER_CHOICE_SAVE);
        });
        box.querySelector("#confirm-cancel").addEventListener("click", () => {
            popupControl.hide();
            resolve(USER_CHOICE_REJECT);
        });
        box.querySelector("#confirm-reject").addEventListener("click", () => {
            popupControl.hide();
            resolve(USER_CHOICE_REJECT);
        });

        const onKeyDownHandler = (event) => {
            const key = event.key;
            if (key === "Escape") {
                document.removeEventListener("keydown", onKeyDownHandler);
                popupControl.hide();
                resolve(USER_CHOICE_CANCEL);
            }
            if (key === "Enter") {
                console.log("on key handler");
                document.removeEventListener("keydown", onKeyDownHandler);
                popupControl.hide();
                resolve(USER_CHOICE_SAVE);
            }
        };
        document.addEventListener("keydown", onKeyDownHandler);

        popupControl.show(box, confirmAccept);
    });
};
